import OperatorReport from '../components/views/operatorReport/OperatorReport.vue'
import ViewOperatorReport from '../components/views/operatorReport/ViewOperatorReport'

const routes = [{
        path: 'operator_report',
        component: OperatorReport,
        name: 'OperatorReport',
        meta: {
            title: 'Operator Report'
        }
    },
    {
        path: 'operator_report/:_id',
        component: ViewOperatorReport,
        name: 'ViewOperatorReport',
        meta: {
            title: 'Operator Report'
        }
    }
]

export default routes


// WEBPACK FOOTER //
// ./src/routes/operatorreport.route.js